import * as types from './types';
import SearchModelProductClass from 'src/model/searchModelProduct.model';
import searchModelProductInstance from './../../../services/search/SearchModelProductService';

import { analyticsActions } from 'src/analytics/store';
import { analyticsListNames } from 'src/analytics/constant';

const searchText = (text: string) => {
  return { type: types.SEARCH_TEXT, payload: text };
};

const searchPage = (page: number) => {
  return { type: types.SEARCH_PAGE, payload: page };
};

const searchResults = (results: SearchModelProductClass) => {
  return { type: types.SEARCH_RESULTS, payload: results };
};

const searchLoading = (isLoading: boolean) => {
  return { type: types.SEARCH_LOADING, payload: isLoading };
};

const searchError = (error: any) => {
  return { type: types.SEARCH_ERROR, payload: error };
};

const search = (text: string, page?: number, onFinish?: any) => {
  return (dispatch: any) => {
    dispatch(searchError(null));
    dispatch(searchText(text));
    dispatch(searchLoading(true));
    if (text) {
      searchModelProductInstance
        .getResults(text, page)
        .then(response => {
          dispatch(searchResults(response));
          dispatch(searchLoading(false));
          if (onFinish) {
            onFinish();
          }
          if (text.length > 2) {
            dispatch(
              analyticsActions.searchResultImpressions({
                list: analyticsListNames.SEARCH_RESULTS,
                listCriteria: text,
                listPage: page ? page + 1 : 1,
                products: response.products
              })
            );
          }
        })
        .catch(err => {
          dispatch(searchError(err));
          dispatch(searchLoading(false));
        });
    }
  };
};

const searchNextPage = () => {
  return (dispatch: any, getState: any) => {
    dispatch(searchError(null));
    dispatch(searchLoading(true));
    const text = getState().search.text;
    let page = getState().search.page;
    const results = getState().search.results;
    page++;
    dispatch(searchPage(page));
    searchModelProductInstance
      .getResults(text, page)
      .then(response => {
        // Append new results to old ones
        const newProducts = response.products;
        response.models = [...results.models, ...response.models];
        response.products = [...results.products, ...response.products];
        dispatch(searchResults(response));
        dispatch(searchLoading(false));
        dispatch(
          analyticsActions.searchResultImpressions({
            list: analyticsListNames.SEARCH_RESULTS,
            listCriteria: text,
            listPage: page ? page + 1 : 1,
            products: newProducts
          })
        );
      })
      .catch(err => {
        dispatch(searchError(err));
        dispatch(searchLoading(false));
      });
  };
};

const resetPage = () => {
  return (dispatch: any, getState: any) => {
    dispatch(searchPage(0));
  };
};

export default {
  searchText,
  searchPage,
  searchResults,
  searchLoading,
  searchError,
  search,
  searchNextPage,
  resetPage
};
